var _ellipse, _path, _path2, _path3, _path4, _ellipse2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4833,
    cy: 10.8095,
    rx: 6.81193,
    ry: 6.81193,
    fill: "#7332FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90309 12.5542C10.0235 12.1722 10.0619 11.7833 9.91301 11.4558C9.55728 10.6732 9.15474 10.0154 8.8286 9.4825C8.65907 9.20549 8.51019 8.9622 8.39924 8.75265C8.25508 8.39223 8.35599 7.67139 9.91301 7.67139C11.6576 7.67139 14.7923 7.93202 17.1364 8.92055C18.7114 8.53102 20.3894 8.3208 22.1307 8.3208C31.2076 8.3208 38.5658 14.0331 38.5658 21.0797C38.5658 28.1262 31.2076 33.8385 22.1307 33.8385C13.0538 33.8385 5.69556 28.1262 5.69556 21.0797C5.69556 17.8024 7.28719 14.8138 9.90309 12.5542Z",
    fill: "#A175FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5073 34.8317V30.7042L20.2924 32.5424L18.9864 35.3286C18.7936 35.7398 18.3804 36.0024 17.9263 36.0024H13.6781C13.0315 36.0024 12.5073 35.4783 12.5073 34.8317Z",
    fill: "#A175FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8508 35.0375L25.4824 32.9749L37.9169 24.7573L32.1934 35.3867C31.9892 35.7659 31.5933 36.0024 31.1626 36.0024H27.0033C26.4361 36.0024 25.9505 35.5958 25.8508 35.0375Z",
    fill: "#A175FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10083 22.384V18.88C3.10083 18.1257 3.71235 17.5142 4.46669 17.5142H8.07462V25.6236L3.87738 23.6162C3.40287 23.3893 3.10083 22.91 3.10083 22.384Z",
    fill: "#A175FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2102,
    cy: 18.1619,
    rx: 1.83814,
    ry: 1.83814,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2604 13.43C27.0842 12.9445 25.7867 12.5872 24.4066 12.3934C22.9086 12.1832 21.451 12.185 20.0941 12.3689",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.0891263bfa10e81a53b16dc566d62e52.svg";
export { ForwardRef as ReactComponent };